import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { formatNumbersDisplayOnly } from '../../../Utils';
import { DeliveryItem } from '../../../Models/DeliveryItem';
import { DeliveryStatusEnum } from '../../../Models/DeliveryStatus';

export default function DeliveryItemNonInventoryListTable({
  data,
  deleteDeliveryItem,
  editDeliveryItem,
  deliveryStatus,
}: {
  data: DeliveryItem[];
  deleteDeliveryItem(id: number): void;
  editDeliveryItem: (inv: DeliveryItem) => void;
  deliveryStatus: number;
}) {
  const columnHelper = createColumnHelper<DeliveryItem>();

  const columns = [
    columnHelper.accessor((row) => row.qbitem?.qbitemName, {
      id: 'qbitemId',
      header: 'Name',
      cell: (info) => (
        <div
          className='cursor-pointer text-blue-600'
          onClick={() => editDeliveryItem(info.row.original)}
        >
          {info.getValue()}
        </div>
      ),
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      // filterFn: 'includesString',
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.quantity, {
      id: 'quantity',
      header: 'Quantity',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.price, {
      id: 'price',
      header: 'Price',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.id, {
      id: 'totalId',
      header: 'Total',
      cell: (info) => (
        <div>
          $
          {formatNumbersDisplayOnly(
            (info.row.original.quantity ?? 0) * (info.row.original.price ?? 0)
          )}
        </div>
      ),
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteDeliveryItem(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: 'id',
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
